import api from '@/store/api/bespoke'
import * as mutationTypes from './mutation-types'
import { handleApiCall } from '@/store/utils'

// Modules
import bespoke from './bespoke'

const initialState = () => ({
    bespokes: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    modules: {
        bespoke
    },
    getters: {
        bespokes: state => state.bespokes.data,
        pagination: state => state.bespokes.pagination
    },
    actions: {
        listBespokes: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.listBespokes, data, mutationTypes.SET_BESPOKES, true),
        resetBespokes: ({commit}) => commit(mutationTypes.RESET_BESPOKES)
    },
    mutations: {
        [mutationTypes.RESET_BESPOKES]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_BESPOKES]: (state, data) => state.bespokes = data
    }
}
